import {
  BrowserCacheLocation,
  Configuration,
  PopupRequest,
} from '@azure/msal-browser';

export const supportServices = [
  'microsoft_outlook',
  'microsoft_one_drive',
  'microsoft_one_note',
] as const;
const baseScopes = ['offline_access', 'openid', 'profile'];

export const serviceScopes: Record<(typeof supportServices)[number], string[]> =
  {
    microsoft_outlook: [...baseScopes, 'Mail.Read'],
    microsoft_one_drive: [...baseScopes, 'Files.Read'],
    microsoft_one_note: [...baseScopes, 'Notes.Read'],
  };

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.CLIENT_ID ?? '',
    authority: `https://login.microsoftonline.com/${
      process.env.TENANT_ID ?? 'common'
    }`,
    redirectUri: process.env.REDIRECT_URI ?? window.location.origin,
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
  },
};

export const microsoftLoginRequest: PopupRequest = {
  scopes: ['openid', 'profile', 'User.Read', 'offline_access'],
  redirectUri: process.env.REDIRECT_URI ?? window.location.origin,
};
